var _rect, _path, _path2, _path3, _g, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.335 30.0544C23.783 30.0544 23.335 29.6064 23.335 29.0543V12.9995C23.335 12.4475 23.783 11.9995 24.335 11.9995C24.887 11.9995 25.335 12.4475 25.335 12.9995V29.0543C25.335 29.6064 24.887 30.0544 24.335 30.0544Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3345 30.0561C24.0691 30.0561 23.8131 29.9507 23.6265 29.7614L19.7384 25.8587C19.3491 25.4667 19.3504 24.8334 19.7411 24.444C20.1331 24.0547 20.7651 24.0547 21.1545 24.4467L24.3345 27.64L27.5145 24.4467C27.9039 24.0547 28.5359 24.0547 28.9279 24.444C29.3185 24.8334 29.3199 25.4667 28.9305 25.8587L25.0425 29.7614C24.8558 29.9507 24.5998 30.0561 24.3345 30.0561Z",
    fill: "#666E7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_12552",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 18,
    width: 27,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18.3101H37.6667V36.6356H11V18.3101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_12552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7669 36.6356H16.9134C13.6534 36.6356 11 33.9835 11 30.7222V24.2088C11 20.9554 13.6467 18.3101 16.9014 18.3101H18.1561C18.7081 18.3101 19.1561 18.7581 19.1561 19.3101C19.1561 19.8621 18.7081 20.3101 18.1561 20.3101H16.9014C14.7494 20.3101 13 22.0581 13 24.2088V30.7222C13 32.8809 14.7547 34.6356 16.9134 34.6356H31.7669C33.9162 34.6356 35.6669 32.8849 35.6669 30.7355V24.2235C35.6669 22.0648 33.9109 20.3101 31.7549 20.3101H30.5122C29.9602 20.3101 29.5122 19.8621 29.5122 19.3101C29.5122 18.7581 29.9602 18.3101 30.5122 18.3101H31.7549C35.0149 18.3101 37.6669 20.9634 37.6669 24.2235V30.7355C37.6669 33.9889 35.0189 36.6356 31.7669 36.6356Z",
    fill: "#666E7D"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    stroke: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0ec89f50e9107e68120bdc41138df60b.svg";
export { ForwardRef as ReactComponent };